import InputBudget from "@libs/forms/InputBudget";
import InputCounter from "@libs/forms/InputCounter";
import InputTextarea from "@libs/forms/InputTextarea";
import { INITIAL_FORM_VALUE, MAX_LENGTH } from "@libs/forms/utils/constants";
import { sanitizeDescription } from "@libs/forms/utils/sanitations";
import RaQFormContentWrapper from "@modules/requestAQuote/components/RaQFormContentWrapper";
import { FiltersContext } from "providers/FiltersProvider";
import React, { useContext, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

interface ILayoutBStepTwo {
  scrollContainerRef?: React.RefObject<HTMLDivElement>;
}

const LayoutBStepTwo = ({
  scrollContainerRef,
}: ILayoutBStepTwo): JSX.Element => {
  const filtersContext: any = useContext(FiltersContext);
  const formContext = useFormContext();
  const [showRooms, setShowRooms] = useState(false);

  const watchFields = formContext.watch(["adults"]);
  useEffect(() => {
    setShowRooms(
      formContext.getValues("adults") > 2
    );
  }, [watchFields]);
  
  return (
    <RaQFormContentWrapper>
      <div className="flex flex-col gap-[12px] mb-[36px]">
        <InputCounter
          name="adults"
          label="Adults"
          sublabel="Ages 13 and above"
          initialValue={INITIAL_FORM_VALUE.adults}
        />
        {/*
        <InputCounter
          name="teens"
          label="Teens"
          sublabel="Ages 12 to 17"
          initialValue={INITIAL_FORM_VALUE.teens}
        />
        */}
        <InputCounter
          name="children"
          label="Children"
          sublabel="Ages 12 and under"
          initialValue={INITIAL_FORM_VALUE.children}
        />
        {showRooms && (
          <InputCounter
            name="rooms"
            label="Number of rooms"
            initialValue={filtersContext.searchQuery.travelers.rooms}
          />
        )}
        <InputBudget
          label={"Lodging Budget Range Per Night"}
          sublabel=""
        />
      </div>
      <InputTextarea
        name="description"
        label="Tell us more about your dream trip."
        maxLength={MAX_LENGTH.description}
        sanitize={sanitizeDescription}
        scrollContainerRef={scrollContainerRef}
      />

    </RaQFormContentWrapper>
  );
};

export default LayoutBStepTwo;
